export default {
    methods: {
        elMsg(msg = 'null', type = 'info', duration = 3000) {
            this.$message({
                message: msg,
                type: type,
                duration: duration,
                showClose: true
            });
            
        }
    }
}